const tabs = {
    get_started: 'Get started',
    dashboard: 'Dashboard',
    applications: 'Applications',
    api_resources: 'API resources',
    sign_in_experience: 'Sign-in & account',
    connectors: 'Connectors',
    enterprise_sso: 'Enterprise SSO',
    security: 'Security',
    webhooks: 'Webhooks',
    actions: 'Actions',
    organizations: 'Organizations',
    users: 'User management',
    audit_logs: 'Audit logs',
    roles: 'Roles',
    docs: 'Docs',
    tenant_settings: 'Settings',
    mfa: 'Multi-factor auth',
    customize_jwt: 'Custom JWT',
    signing_keys: 'Signing keys',
    organization_template: 'Organization template',
    iam_sync_users: 'IAM sync',
    iam_staff_import: 'Import users',
    iam_systems: 'Integrated systems',
};
export default Object.freeze(tabs);
